import { useQuery } from '@tanstack/react-query'
import { ApiRequestError, getSupplierSettings } from '@/services/api'
import type { OrderConfirmationSettings } from '@/types/orderConfirmationSettings'

export const supplierSettingsQueryKey = (workflowId: string, supplierId: string) =>
  ['supplier-settings', workflowId, supplierId] as const

export function useSupplierSettings(
  workflowId: string | undefined,
  supplierId: string | undefined,
  enabled = true,
) {
  return useQuery({
    queryKey: supplierSettingsQueryKey(workflowId ?? '', supplierId ?? ''),
    queryFn: async (): Promise<OrderConfirmationSettings | null> => {
      try {
        return await getSupplierSettings(workflowId!, supplierId!)
      } catch (error) {
        if (error instanceof ApiRequestError && error.status === 404) {
          return null
        }
        throw error
      }
    },
    enabled: !!workflowId && !!supplierId && enabled,
    staleTime: 60 * 1000,
  })
}
